import React from 'react';
import { ContentCard } from '../../components/Dashboard/Card/Card'
import { Card_2 } from '../../components/Dashboard/Card_2/Card_2'
import { TableCard } from '../../components/Dashboard/Table/Table'
import Chart from '../../components/Dashboard/Chart/Chart'
import { Layout } from 'antd';
import { } from '@ant-design/icons';
import './Dashboard.css'
import { Card_3 } from '../../components/Dashboard/Card_3/Card_3';
import AppLayout from '../../components/Layout/AppLayout'


const { Content } = Layout;

const Dashboard = () => {

  return (
    <AppLayout
      title="Dashboard"
    >
      <Content
        className="site-layout-content-card-container"
        style={{
          margin: '30px 30px 0px 30px',
          minHeight: 100,
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          flexGrow: 0,
        }}
      >
        <ContentCard
          icon={<i class="fas fa-user"></i>}
          text="Cases Added This Month"
          number={16}
          bgColor='#6777ef'
        />
        <ContentCard
          icon={<i class="far fa-newspaper"></i>}
          text="Total Cases Added"
          number={95}
          bgColor='#fc544b'
        />
        <ContentCard
          icon={<i class="far fa-file"></i>}
          text="Tasks"
          number={4}
          bgColor='#ffa426'
        />
        <ContentCard
          icon={<i class="fas fa-circle"></i>}
          text="Reminder"
          number={1}
          bgColor="#63ed7a"
        />
      </Content>


      <Layout
        style={{
          display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
          margin: '0px 30px'
        }}
      >
        <Layout style={{
          flex: '0 1 64%',
          minWidth: '300px',
        }} >

          <Content
            className="site-layout-content"
            style={{
              margin: '0px 0px 0px 0px',
              // padding: 10,
              minHeight: 250,
              flexGrow: 1,
            }}
          >
            <Chart />
          </Content>

          <Content
            className="site-layout-content"
            style={{
              margin: '30px 0px 30px 0px',
              padding: 0,
              minHeight: 280,
              flexGrow: 1,
            }}
          >
            <Card_2 />
          </Content>
        </Layout>

        <Layout style={{
          flex: '0 1 33%',
          minWidth: '200px',
          margin: '0px 0px 30px 0px',
        }} >
          <Content
            className="site-layout-content"
            style={{
              margin: '0px 0px 0px 0px',
              minHeight: 280,
              flexGrow: 1,
            }}
          >
            <Card_3 />
          </Content>
        </Layout>

      </Layout>

      <Layout
        style={{
          display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
          margin: '0px 30px'
        }}
      >
        <Content
          className="site-layout-content"
          style={{
            margin: '0px 0px 30px 0px',
          }}
        >
          <TableCard />
        </Content>
      </Layout>

    </AppLayout>

  );
}

export default Dashboard;
